import { render } from "./scoreQuery.vue?vue&type=template&id=5f5d7162"
import script from "./scoreQuery.vue?vue&type=script&lang=js"
export * from "./scoreQuery.vue?vue&type=script&lang=js"

import "./scoreQuery.vue?vue&type=style&index=0&id=5f5d7162&lang=scss"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__